import React from 'react';

// 確認ポップアップコンポーネント
export const InsuranceApplicationListPop = ({
  showConfirmationPopup,
  confirmationPopupData,
  comments,
  closeConfirmationPopup,
  finalizeStatusChange
}) => {
  if (!showConfirmationPopup || !confirmationPopupData) return null;
  
  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">申請内容確認</h2>
          
          <div className="confirmation-details">
            <div className="confirmation-row">
              <div className="confirmation-label font-big">保険会社名：</div>
              <div className="confirmation-value">{confirmationPopupData.company}</div>
              <div className="confirmation-date">{confirmationPopupData.date}</div>
            </div>
            
            <div className="confirmation-row u-mb-10">
              <div className="confirmation-label application-agency">{confirmationPopupData.agency}</div>
              {/* ステータスの表示方法を変更 */}
              <div className="confirmation-status">
                <span 
                  className={`status-tag status-${confirmationPopupData.status}`}
                >
                  {confirmationPopupData.status || 'ステータス未設定'}
                </span>
              </div>
            </div>
            <div className="comment-header u-mt-medium">申請書類</div>
              <div className="confirmation-files">
                <div className="confirmation-file-item">
                  <div className="file-path">合計ファイル数</div>
                    <div className="file-count">
                      {confirmationPopupData.files.length}部
                    </div>
                </div>
              {confirmationPopupData.files.map((file, index) => (
                <div key={index} className="confirmation-file-item">
                  <div className="file-path">
                    {typeof file === 'object' ? (file.filename || 'ファイル名なし') : file}
                  </div>
                  <div className="file-count">
                    1部
                  </div>
                </div>
              ))}
            </div>

            {confirmationPopupData.status === '却下' && (
              <div className="confirmation-comment">
                <div className="comment-header">コメント</div>
                <div className="comment-content">
                  {comments[confirmationPopupData.id] || ''}
                </div>
              </div>
            )}
          </div>
          
          <div className="action-buttons c-max-mini c-m-center">
            <button 
              className="button button-secondary button-medium" 
              onClick={closeConfirmationPopup}
            >
              戻る
            </button>
            <button 
              className="btn btn-primary button-medium" 
              onClick={finalizeStatusChange}
            >
              確定する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceApplicationListPop;